import clonedeep from 'lodash.clonedeep';
import omit from 'lodash.omit';
import { pick } from 'underscore';

import { FORM_RESPONSE_FIELD_PROPS, MESSAGE_TYPES, ACTION_TYPES, ROLES } from '../constants/message';
import { sendPostback } from '../actions/conversation';
import { showWebview } from '../actions/webview';

export function shouldIgnoreText(type) {
    return type === MESSAGE_TYPES.LOCATION;
}

export function isSupportedMessageType(type) {
    return Object.values(MESSAGE_TYPES).includes(type);
}

export function isSupportedActionType(type) {
    return Object.values(ACTION_TYPES).includes(type);
}

export function filterClientProps(message) {
    return omit(message, [
        '_clientId',
        '_clientSent',
        'firstInGroup',
        'firstMessageOfDay',
        'lastInGroup',
        'shouldShowAuthor',
        'shouldShowAvatar',
    ]);
}

export function getLocationKey(coordinates) {
    return `${coordinates.long}:${coordinates.lat}`;
}

export function executeAction(dispatch, action) {
    const { _id, type, size, uri } = action;

    if (type === 'link') {
        return window.open(uri, '_blank');
    }

    if (type === 'postback') {
        return dispatch(sendPostback(_id));
    }

    if (type === 'webview') {
        return dispatch(
            showWebview({
                uri,
                size,
            }),
        );
    }
}

export function generateForm(fields, { blockChatInput = false } = {}) {
    return {
        type: MESSAGE_TYPES.FORM,
        role: 'appMaker',
        fields: clonedeep(fields),
        blockChatInput,
        received: Date.now() / 1000,
    };
}

/**
 *
 * @param {Array<Object>} fields
 * @param {string} formId
 * @param {Object<string, string|Array<{label: string, name: string}>} submittedFields
 */
export function generateFormResponse(fields, formId, submittedFields) {
    return {
        type: MESSAGE_TYPES.FORM_RESPONSE,
        role: 'appUser',
        fields: fields.map((field) => {
            const responseField = pick(field, FORM_RESPONSE_FIELD_PROPS);
            responseField[field.type] = submittedFields[field.name];
            return responseField;
        }),
        quotedMessageId: formId,
    };
}

export function isCurrentUserMessage(message, currentUserId) {
    return message.role === ROLES.APP_USER && (!message.authorId || message.authorId === currentUserId);
}

export function areFromSameAuthor(msg1, msg2) {
    if (msg1.role !== msg2.role) {
        return false;
    }

    return msg1.authorId === msg2.authorId && msg1.name === msg2.name;
}
